import {
  GET_SUB_ADMINS,
  CREATE_SUB_ADMIN,
  UPDATE_SUB_ADMIN,
  DELETE_SUB_ADMIN,
  GET_PERMISSIONS,
  SET_SUB_ADMIN_LOADING,
  SUB_ADMIN_ERROR
} from "./subAdmin.type";

const initialState = {
  subAdmins: [],
  permissions: { modules: [], actions: [] },
  loading: false,
  error: null,
  totalSubAdmins: 0
};

const subAdminReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SUB_ADMIN_LOADING:
      return { ...state, loading: action.payload };

    case GET_SUB_ADMINS:
      return {
        ...state,
        subAdmins: action.payload.subAdmins,
        totalSubAdmins: action.payload.total,
        loading: false
      };

    case GET_PERMISSIONS:
      return { ...state, permissions: action.payload, loading: false };

    case CREATE_SUB_ADMIN:
      return {
        ...state,
        subAdmins: [action.payload, ...state.subAdmins],
        loading: false
      };

    case UPDATE_SUB_ADMIN:
      return {
        ...state,
        subAdmins: state.subAdmins.map(admin =>
          admin._id === action.payload._id ? action.payload : admin
        ),
        loading: false
      };

    case DELETE_SUB_ADMIN:
      return {
        ...state,
        subAdmins: state.subAdmins.filter(admin => admin._id !== action.payload),
        loading: false
      };

    case SUB_ADMIN_ERROR:
      return { ...state, error: action.payload, loading: false };

    default:
      return state;
  }
};

export default subAdminReducer;